module.exports = __webpack_public_path__ + "img/hotel-31.98f8bba0.jpeg";